import { render, staticRenderFns } from "./modal-slide.vue?vue&type=template&id=2e065ecb&scoped=true"
import script from "./modal-slide.vue?vue&type=script&lang=ts"
export * from "./modal-slide.vue?vue&type=script&lang=ts"
import style0 from "./modal-slide.vue?vue&type=style&index=0&id=2e065ecb&prod&lang=scss&scoped=true"
import style1 from "./modal-slide.vue?vue&type=style&index=1&id=2e065ecb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e065ecb",
  null
  
)

export default component.exports